import { API_PRECOG_URL_V1 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { displayErrorToast } from "../overflowNotification";

export const PATCH_SINGLE_ACCOUNTING_LINE_START = "PATCH_SINGLE_ACCOUNTING_LINE_START";
export const PATCH_SINGLE_ACCOUNTING_LINE_SUCCESS = "PATCH_SINGLE_ACCOUNTING_LINE_SUCCESS";
export const PATCH_SINGLE_ACCOUNTING_LINE_ERROR = "PATCH_SINGLE_ACCOUNTING_LINE_ERROR";

export const CREATE_SINGLE_ACCOUNTING_LINE_START = "CREATE_SINGLE_ACCOUNTING_LINE_START";
export const CREATE_SINGLE_ACCOUNTING_LINE_SUCCESS = "CREATE_SINGLE_ACCOUNTING_LINE_SUCCESS";
export const CREATE_SINGLE_ACCOUNTING_LINE_ERROR = "CREATE_SINGLE_ACCOUNTING_LINE_ERROR";

export const SPLIT_ACCOUNTING_LINE_START = "SPLIT_ACCOUNTING_LINE_START";
export const SPLIT_ACCOUNTING_LINE_SUCCESS = "SPLIT_ACCOUNTING_LINE_SUCCESS";
export const SPLIT_ACCOUNTING_LINE_ERROR = "SPLIT_ACCOUNTING_LINE_ERROR";

export const DELETE_GROUP_ACCOUNTING_LINE_START = "DELETE_GROUP_ACCOUNTING_LINE_START";
export const DELETE_GROUP_ACCOUNTING_LINE_SUCCESS = "DELETE_GROUP_ACCOUNTING_LINE_SUCCESS";
export const DELETE_GROUP_ACCOUNTING_LINE_ERROR = "DELETE_GROUP_ACCOUNTING_LINE_ERROR";

export const DELETE_SINGLE_ACCOUNTING_LINE_START = "DELETE_SINGLE_ACCOUNTING_LINE_START";
export const DELETE_SINGLE_ACCOUNTING_LINE_SUCCESS = "DELETE_SINGLE_ACCOUNTING_LINE_SUCCESS";
export const DELETE_SINGLE_ACCOUNTING_LINE_ERROR = "DELETE_SINGLE_ACCOUNTING_LINE_ERROR";

export const GET_ACCOUNT_ARTICLES_START = "GET_ACCOUNT_ARTICLES_START";
export const GET_ACCOUNT_ARTICLES_SUCCESS = "GET_ACCOUNT_ARTICLES_SUCCESS";
export const GET_ACCOUNT_ARTICLES_ERROR = "GET_ACCOUNT_ARTICLES_ERROR";

export const CLEAR_ACCOUNT_ARTICLES = "CLEAR_ACCOUNT_ARTICLES";

export function updateAccountingLine(
  draftId, uuidToModify, accountingLine, parentId, totalAmountForCO1
) {
  
  return (dispatch, getState) => {
    const auth = getState().auth;    
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    let url = `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/accountingLines?itemId=${itemId}&managerId=${managerId}`;
    if (Array.isArray(uuidToModify)) {
      url = url + `&accountingLineIdList=${uuidToModify}`;
    } else {
      url = url + `&groupId=${uuidToModify}`;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "PATCH",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: accountingLine
      };

      dispatch({
        type: PATCH_SINGLE_ACCOUNTING_LINE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: PATCH_SINGLE_ACCOUNTING_LINE_SUCCESS,
              payload: { ...result, parentId: parentId, totalAmountForCO1: totalAmountForCO1 }
            });
            // mi serve per forza far ricaricare perchè quando un children ha una modifica 
            // ora il BE mi ricalcola alcune righe per cui è impossibile sistemare a FE
            dispatch({ type: "SET_ACCOUNTS_REFRESH" });
            resolve(result.data);
          } else {
            dispatch({
              type: PATCH_SINGLE_ACCOUNTING_LINE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          if (response?.response?.data?.message === "AccountingLine duplicated") {
            dispatch(displayErrorToast("Hai già un conto con lo stesso segno.", "Attenzione"));
          }
          dispatch({
            type: PATCH_SINGLE_ACCOUNTING_LINE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function createAccountingLine(
  draftId, accountingLine, groupId
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    let url = `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/accountingLines?itemId=${itemId}&managerId=${managerId}`;
    if (groupId) {
      url = `${url}&groupId=${groupId}`;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: url,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: accountingLine
      };

      dispatch({
        type: CREATE_SINGLE_ACCOUNTING_LINE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: CREATE_SINGLE_ACCOUNTING_LINE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: CREATE_SINGLE_ACCOUNTING_LINE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          if (response?.response?.data?.message === "AccountingLine duplicated") {
            dispatch(displayErrorToast("Valorizza l'importo del conto prima di inserirne uno uguale.", "Attenzione"));
          }
          dispatch({
            type: CREATE_SINGLE_ACCOUNTING_LINE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function splitAccountingLine(draftId, lineToSplit) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/accountingLines/split?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: lineToSplit
      };

      dispatch({
        type: SPLIT_ACCOUNTING_LINE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: SPLIT_ACCOUNTING_LINE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: SPLIT_ACCOUNTING_LINE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          if (response?.response?.data?.message === "AccountingLine duplicated") {
            dispatch(displayErrorToast("Valorizza l'importo del conto prima di inserirne uno uguale.", "Attenzione"));
          }
          dispatch({
            type: SPLIT_ACCOUNTING_LINE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function deleteAccountingGroupLine(draftId, lineId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "DELETE",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/accountingLines/group/${lineId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: DELETE_GROUP_ACCOUNTING_LINE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: DELETE_GROUP_ACCOUNTING_LINE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: DELETE_GROUP_ACCOUNTING_LINE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: DELETE_GROUP_ACCOUNTING_LINE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function deleteSingleAccountingLine(draftId, lineId) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    return new Promise((resolve, reject) => {
      let request = {
        method: "DELETE",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${draftId}/accountingLines/single/${lineId}?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      dispatch({
        type: DELETE_SINGLE_ACCOUNTING_LINE_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: DELETE_SINGLE_ACCOUNTING_LINE_SUCCESS,
              payload: result
            });
            resolve(result.data);
          } else {
            dispatch({
              type: DELETE_SINGLE_ACCOUNTING_LINE_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: DELETE_SINGLE_ACCOUNTING_LINE_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function getAccountArticles(
  invoiceId, accountId, page
) {
  if (!invoiceId) return undefined;
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantUuidSelected;
    const itemId = getState().main.companyUuidSelected;
    dispatch({
      type: GET_ACCOUNT_ARTICLES_START,
      payload: {
        page: page ? page : 0
      }
    });
    return new Promise((resolve, reject) => {
      let request = {
        method: "GET",
        url: `${API_PRECOG_URL_V1}/precog/drafts/${invoiceId}/accountingLines/${accountId}?page=${page ? page : 0}&itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then(async(result) => {
          if (result.status === 200 || result.status === 202) {
            result.page = page ? page : 0;
            dispatch({
              type: GET_ACCOUNT_ARTICLES_SUCCESS,
              payload: result
            });
            resolve(result);
          } else {
            dispatch({
              type: GET_ACCOUNT_ARTICLES_ERROR,
              error: result
            });
            reject();
          }
        })
        .catch((response) => {
          dispatch({
            type: GET_ACCOUNT_ARTICLES_ERROR,
            error: response
          });
          reject();
        });
    });
  };
}

export function clearAccountArticles() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_ACCOUNT_ARTICLES
    });
  };
}
